import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SFStack } from "../../grid";
import SFTypography from "../../../components/typography";
import SFButton from "../../../components/button";

const ActionBtns = ({ onEditFilters, onShowLess, onDeleteAll, readOnly }) => {
  const { t } = useTranslation();
  return (
    <SFStack direction="row" spacing={1}>
      {!readOnly && (
        <SFButton variant="text-link" onClick={onEditFilters}>
          <SFTypography>{t("components.filterChip.editFilters")}</SFTypography>
        </SFButton>
      )}
      {onShowLess && (
        <SFButton variant="text-link" onClick={onShowLess}>
          <SFTypography>{t("components.filterChip.showLess")}</SFTypography>
        </SFButton>
      )}
      {onDeleteAll && !readOnly && (
        <SFButton variant="text-link" onClick={onDeleteAll}>
          <SFTypography>{t("components.filterChip.clearAll")}</SFTypography>
        </SFButton>
      )}
    </SFStack>
  );
};

ActionBtns.propTypes = {
  onEditFilters: PropTypes.func,
  onShowLess: PropTypes.func,
  onDeleteAll: PropTypes.func,
};

export default ActionBtns;
